// extracted by mini-css-extract-plugin
module.exports = {"poem":"poem_poem__TVws9","red":"poem_red__24nFc"};